var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeclineRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.70708 5.70708C6.0976 5.31655 6.73077 5.31655 7.12129 5.70708L9.94974 8.53552L12.7782 5.70709C13.1687 5.31656 13.8019 5.31656 14.1924 5.70709C14.5829 6.09761 14.5829 6.73078 14.1924 7.1213L11.364 9.94974L14.1924 12.7781C14.5829 13.1687 14.5829 13.8018 14.1924 14.1924C13.8018 14.5829 13.1687 14.5829 12.7781 14.1924L9.94974 11.364L7.12132 14.1924C6.7308 14.5829 6.09763 14.5829 5.70711 14.1924C5.31658 13.8018 5.31658 13.1687 5.70711 12.7782L8.53552 9.94974L5.70708 7.12129C5.31655 6.73077 5.31655 6.0976 5.70708 5.70708Z",
    fill: "#E61937"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeclineRed);
export default __webpack_public_path__ + "static/media/icon-decline-red.e6047df9332060c2d4b85fd73ff64698.svg";
export { ForwardRef as ReactComponent };